<footer class="usa-footer__primary-section">
    <div class="grid-container">
        <div class="grid-row grid-gap padding-bottom-4">
            <div class="desktop:grid-col-3 flex-1">
                <p class="text-bold">Government-wide Initiatives</p>
                <ul class="add-list-reset line-height-sans-6">
                    <li> <a href="https://www.gsa.gov/technology/government-it-initiatives/digital-strategy" target="_blank">Digital Strategy</a></li>
                    <li> <a href="https://www.plainlanguage.gov/" target="_blank">Plain Language </a></li>
                    <li> <a href="https://designsystem.digital.gov/" target="_blank">U.S. Web Design System </a></li>
                    <li> <a href="https://www.cio.gov/about/members-and-leadership/accessibility-cop/" target="_blank">CIO Council Accessibility Community of Practice</a></li>
                </ul>
            </div>
            <div class="desktop:grid-col-3 flex-1">
                <p class="text-bold">Organization</p>
                <ul class="add-list-reset line-height-sans-6">
                    <li> <a href="https://www.section508.gov/about-us/" aria-label="About Us in Organization"> About Us</a></li>
                    <li> <a aria-label="Contact Us details" href="https://www.section508.gov/contact-us/"> Contact Us</a></li>
                    <li><a href="https://www.section508.gov/contributors/" aria-label="Section508.gov site Contributors"> Contributors</a></li>
                    <li><a href="https://www.section508.gov/manage/join-the-508-community/">Join the Community(Listserv)</a></li>
                </ul>
            </div>
            <div class="desktop:grid-col-3 flex-1">
                <p class="text-bold">Tools</p>
                <ul class="add-list-reset line-height-sans-6">
                    <li> <a href="https://www.section508.gov/art" aria-label="Accessibility Requirements Tool"> ART</a></li>
                    <li> <a href="https://www.section508.gov/buy/solicitation-review-tool" aria-label="Solicitation Review Tool"> SRT</a></li>
                    <li> <a href="https://www.section508.gov/content/guide-accessible-web-design-development"> Developer Guide</a></li>
                    <li> <a href="https://digitaldashboard.gov/" target="_blank"> DigitalDashboard.gov</a></li>
                    <li> <a href="https://analytics.usa.gov/" target="_blank"> Analytics.usa.gov</a></li>
                </ul>
            </div>
            <div class="desktop:grid-col-3 flex-1">
                <p class="text-bold">Resources</p>
                <ul class="add-list-reset line-height-sans-6">
                    <li> <a href="https://www.section508.gov/tools/glossary">Glossary of Terms</a></li>
                    <li><a href="https://www.section508.gov/tools/acronyms-abbreviations/">Acronyms & Abbreviations</a></li>
                    <li> <a href="https://www.section508.gov/website-policies"> Website Policies</a></li>
                    <li> <a href="https://www.section508.gov/tools/coordinator-listing"> Find Your Section 508 Program Manager</a></li>
                </ul>
            </div>
        </div>
    </div>
    <!-- <div class="usa-footer__secondary-section">
        <div class="grid-container">
            <div class="grid-row grid-gap">
                <div class="usa-footer__logo grid-row tablet:grid-col-12">
                    <div class="tablet:grid-col-3 desktop:grid-col-4 margin-y-1">
                        <a href="https://www.gsa.gov/" aria-label="General Services Administration" target="_blank">
                        <img alt="General Service Administration" class="usa-footer__logo-img margin-right-1" width="42" valign="middle" integrity="sha512-5ciC+l/ipR9VSnpK/i6PqrSHd0/pMTEBs6nArXajxdJ2S+59+E/itSW10iB2emnqYwwo1lYSTAXMiRp7TMGStg==" crossorigin="anonymous" src="{{url}}/assets/images/gsa-logo.png">General Services Administration </a>
                    </div>
                    <div class="tablet:grid-col-3 margin-y-1">
                        <a href="https://www.access-board.gov/" target="_blank" aria-label="US Access Board">
                        <img alt="US Access Board" class="usa-footer__logo-img margin-right-1" width="42" valign="middle" integrity="sha512-YCOEKxFp6bB4M71udl46ogBIO6Ai2DBjoRHDIeMnqCWjsBaq2tNQsyp+29cthfOYwCTNnxxS2jpxzWEUNZqV6g==" crossorigin="anonymous" src="{{url}}/assets/images/seal-usab.png">US Access Board </a>
                    </div>
                    <div class="tablet:grid-col-3 margin-y-1">
                        <a href="https://www.section508.gov/manage/join-the-508-community/" target="_blank" aria-label="Joining listserv">
                        Join the Community(Listserv)</a>
                    </div> 
                </div>
            </div>
        </div>
    </div> -->
</footer>
<div class="usa-identifier">
    <section class="usa-identifier__section usa-identifier__section--masthead" aria-label="Agency identifier,">
      <div class="usa-identifier__container">
        <div class="usa-identifier__logos">
          <a href="https://gsa.gov" class="usa-identifier__logo">
              <img class="usa-identifier__logo-img" alt="General Services Administration Logo" integrity="sha512-5ciC+l/ipR9VSnpK/i6PqrSHd0/pMTEBs6nArXajxdJ2S+59+E/itSW10iB2emnqYwwo1lYSTAXMiRp7TMGStg==" crossorigin="anonymous" src="{{url}}/assets/images/gsa-logo-md.png">
          </a>
        </div>
        <div class="usa-identifier__identity" aria-label="Agency description">
          <p class="usa-identifier__identity-domain">Section508.gov</p>
          <p class="usa-identifier__identity-disclaimer">
            An official website of the <a href="https://www.gsa.gov/">General Services Administration</a>
          </p>
        </div>
      </div>
    </section>
    <nav class="usa-identifier__section usa-identifier__section--required-links" aria-label="Important links,,">
      <div class="usa-identifier__container">
        <ul class="usa-identifier__required-links-list">
          <li class="usa-identifier__required-links-item">
            <a href="https://www.gsa.gov/about-us" class="usa-identifier__required-link usa-link">About GSA</a>
          </li>
          <li class="usa-identifier__required-links-item">
            <a href="https://www.gsa.gov/website-information/accessibility-aids" class="usa-identifier__required-link usa-link">Accessibility support</a>
          </li>
          <li class="usa-identifier__required-links-item">
            <a href="https://www.gsa.gov/reference/freedom-of-information-act-foia" class="usa-identifier__required-link usa-link">FOIA requests</a>
          </li>
          <li class="usa-identifier__required-links-item">
            <a href="https://www.gsa.gov/reference/civil-rights-programs/notification-and-federal-employee-antidiscrimination-and-retaliation-act-of-2002" class="usa-identifier__required-link usa-link">No FEAR Act data</a>
          </li>
          <li class="usa-identifier__required-links-item">
            <a href="https://www.gsaig.gov/" class="usa-identifier__required-link usa-link">Office of the Inspector General</a>
          </li>
          <li class="usa-identifier__required-links-item">
            <a href="https://www.gsa.gov/reference/reports/budget-performance" class="usa-identifier__required-link usa-link">Performance reports</a>
          </li>
          <li class="usa-identifier__required-links-item">
            <a href="https://www.gsa.gov/website-information/website-policies" class="usa-identifier__required-link usa-link">Privacy policy</a>
          </li>
          <li class="usa-identifier__required-links-item">
            <a href="https://www.section508.gov/website-policies/#reuse-and-copyright" class="usa-identifier__required-link usa-link">Reuse and Copyright</a>
          </li>
        </ul>
      </div>
    </nav>
    <section class="usa-identifier__section usa-identifier__section--usagov" aria-label="U.S. government information and services,,">
      <div class="usa-identifier__container">
        <div class="usa-identifier__usagov-description">
          Looking for U.S. government information and services?
        </div>
        <a href="https://www.usa.gov/" class="usa-link">Visit USA.gov</a>
      </div>
    </section>
  </div>
